document.addEventListener("DOMContentLoaded", function () {
  const hoverItems = document.querySelectorAll('.pd-hover-menu-item');
  const svgImage = document.getElementById('menu-slider-image');

  if (!svgImage) return;
  

  let currentImage = svgImage.getAttribute('href');
  let fadeTimeout;

  hoverItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      const newImage = item.getAttribute('data-image');

      if (!newImage || newImage === currentImage) return;

      clearTimeout(fadeTimeout);

      // Optional: brief fade effect using opacity class
      svgImage.classList.remove('active');
      fadeTimeout = setTimeout(() => {
        svgImage.setAttribute('href', newImage);
        currentImage = newImage;
        requestAnimationFrame(() => {
          svgImage.classList.add('active');
        });
      }, 150);
    });

    item.addEventListener('mouseleave', () => {
      clearTimeout(fadeTimeout);
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const maskedSections = document.querySelectorAll(
    ".pd-mask--type-curve-bottom, .pd-mask--type-waves-bottom"
  );
  let z = maskedSections.length;
  maskedSections.forEach((section) => {
    section.style.zIndex = 10 + z; // or just z if you're controlling full range
    section.style.position = "relative";
    z--;
  });
});

document.addEventListener('DOMContentLoaded', function () {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animated");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.8
      }
    );

    const animationDrawItems = document.querySelectorAll('.animation-draw');

    animationDrawItems.forEach(item => {
      observer.observe(item);
    });
  });

document.addEventListener('DOMContentLoaded', function () {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animated");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.5
      }
    );

    const animatedElements = document.querySelectorAll('.animation-fade');

    animatedElements.forEach((item, index) => {
      // Set inline style for delay: 0s for first, then +0.2s per item
      const delay = Math.min(index, 3) * 0.2; // max 0.6s delay for 4 items
      item.style.transitionDelay = `${delay}s`;
  
      observer.observe(item);
    });
  });